<!-- @format -->

<div class="modal-header">
  <h2 class="modal-title" [tabIndex]="0" translate>{{ values.title }}</h2>
</div>
<div class="modal-body">
  @for (notification of notifications; track notification) {
    <sis-contextual-notification variant="warning" class="modal-notification">
      <span>{{ notification }}</span>
    </sis-contextual-notification>
  }

  @for (description of descriptions; track description) {
    <p data-cy="electronicPrintModalWindowBody">
      <transloco [content]="description | translate: { name: values.name }" />
    </p>
  }

  @if (values.objects) {
    <p>
      <transloco [content]="values.listTitle | translate: { count: values.objects.length }" />
    </p>
  }
  <ul class="objects">
    @for (object of values.objects; track object) {
      <li class="object">
        {{ object }}
      </li>
    }
  </ul>
  @for (descriptionSet of values.descriptionSets; track descriptionSet) {
    <div>
      @for (description of descriptionSet.descriptions; track description) {
        <p>
          <transloco [content]="description | translate: { name: descriptionSet.name }" />
        </p>
      }
      @if (descriptionSet.listTitle) {
        <p>
          <transloco [content]="values.listTitle | translate: { count: descriptionSet.objects.length }" />
        </p>
      }
      <ul class="objects">
        @for (object of descriptionSet.objects; track object) {
          <li class="object">
            {{ object }}
          </li>
        }
      </ul>
    </div>
  }
</div>
<div class="modal-footer confirm-dialog-footer">
  @if (!values.hideCancel) {
    <button
      class="btn btn-primary btn-hollow btn-lg"
      data-cy="confirm-dialog-cancel"
      type="button"
      (click)="modalInstance.dismiss()"
      [translate]="values.cancelText || 'SIS_COMPONENTS.CONFIRM.CANCEL'"></button>
  }
  <button
    class="btn btn-primary btn-lg"
    data-cy="confirm-dialog-confirm"
    type="button"
    (click)="close()"
    [translate]="values.confirmText || 'SIS_COMPONENTS.CONFIRM.YES'"></button>
</div>
